import _ from "lodash";

export default function(state = this.initialValue, action) {

    switch (action.type) {
        case this.selectedAction:
            const ids = _.map(action.payload.data.data, this.idSelector);
            const pageNumber = action.payload.postedData.pageNumber;
            return {...state, [pageNumber]: ids};
        default:
            return state;
    }

};